import { defineComponent as _defineComponent } from 'vue'
import Tooltip from '../../tooltip/Tooltip.vue';
import TooltippedText from '../../tooltip/TooltippedText/TooltippedText.vue';
import { computed, ref, watch } from 'vue';
import vuetify from '../../../service/useVuetify';
import { IntersectionStateChanger, NavBarItems } from '@/utils/types';
import NavSubItemList from './NavSubItemList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavItems',
  props: {
    mini: { type: Boolean },
    expandTooltip: { default: '' },
    collapseTooltip: { default: '' },
    items: null
  },
  emits: ["update:mini", "subItemClicked", "infiniteHandler"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:mini", mini: boolean): void;
  (e: "subItemClicked", i: number, subItemIndex?: number): void;
  (e: "infiniteHandler", parentIndex: number, state: IntersectionStateChanger): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mini: boolean, expandTooltip: string, collapseTooltip: string, items: NavBarItems };





const mobileMenuToggled = ref(false);
const computedItems = computed(() => props.items);

watch(
  () => vuetify.value.breakpoint.mdAndDown,
  (isSmallerScreen) => {
    if(isSmallerScreen) emit('update:mini', true);
  }
);

function subItemClicked(parentIndex: number, subItemIndex?: number) {
  emit('subItemClicked', parentIndex, subItemIndex);
}

function handleIntersection(parentIndex: number, state: IntersectionStateChanger) {
  emit('infiniteHandler', parentIndex, state)
}

function collapser() {
  mobileMenuToggled.value = props.mini;
  emit('update:mini', !props.mini);
}

function handleItemClick(i: number) {
  if(computedItems.value[i].active) {
    mobileMenuToggled.value = true;
  }
  emit('subItemClicked', i);
}

return { __sfc: true,props, emit, mobileMenuToggled, computedItems, subItemClicked, handleIntersection, collapser, handleItemClick, Tooltip, TooltippedText, vuetify, NavSubItemList }
}

})